export enum MaintenanceIntervalType {
  AsNeeded = 'As Needed',
  DailyCheck = 'Daily Check',
  Annually = 'Annually',
  EveryXYears = 'Every X Years',
  EveryXMonths = 'Every X Months',
  Seasonally = 'Seasonally',
  XYears = 'X Years',
  XMonths = 'X Months',
  XHours = 'X Hours',
  EveryXHours = 'Every X Hours',
}
